import { flattenContentfulObject } from '../services/contentful';
// ---------- TYPES ----------
export var ContributorType;
(function (ContributorType) {
    ContributorType["Author"] = "author";
    ContributorType["Photographer"] = "photographer";
    ContributorType["Videographer"] = "videographer";
    ContributorType["Illustrator"] = "illustrator";
    ContributorType["Partner"] = "partner";
    ContributorType["Podcaster"] = "podcaster";
    ContributorType["Backend"] = "backend";
})(ContributorType || (ContributorType = {}));
// ---------- FUNCTIONS ----------
export const parseContributor = (data) => {
    if (!data || !data.fields) {
        return;
    }
    return {
        ...data.fields,
        id: data.sys.id,
        photo: data.fields.photo
            ? flattenContentfulObject(data.fields.photo)
            : undefined
    };
};
export const getContributors = async (contentfulClient) => {
    const response = await contentfulClient.getEntries({
        content_type: 'contributor',
        include: 4,
        limit: 1000
    });
    return response.items
        .map((c) => parseContributor(c))
        .filter((c) => c !== undefined);
};
//# sourceMappingURL=contributors.js.map